require('dotenv').config();
/* eslint-disable max-len */

const isProduction = process.env.NODE_ENV === 'production';

// Change this when build for production
// const CLIENT_BACKEND_ENDPOINT_URL = 'http://localhost:3000';
const CLIENT_BACKEND_ENDPOINT_URL = isProduction ? 'https://apps.asaplombok.com' : 'https://dev-superapp.asaplombok.com';
// const CLIENT_BACKEND_ENDPOINT_URL = 'https://dev-superapp.asaplombok.com';

module.exports = {
  isProduction,
  // default locale is the first one
  locales: [
    /* @intl-code-template '${lang}-${COUNTRY}', */
    'en-US',
    // 'es',``
    // 'fr-FR',
    'id-ID',
    // 'ja-JA',
    // 'ru-RU',
    // 'ar'
    /* @intl-code-template-end */
  ],

  // Node.js app
  port: process.env.PORT || 3000,

  // https://expressjs.com/en/guide/behind-proxies.html
  trustProxy: process.env.TRUST_PROXY || 'loopback',

  // SITE URL
  siteUrl: process.env.SITE_URL || CLIENT_BACKEND_ENDPOINT_URL,

  // API Gateway
  api: {
    // API URL to be used in the client-side code
    clientUrl: process.env.API_CLIENT_URL || '',
    // API URL to be used in the server-side code
    serverUrl: `${CLIENT_BACKEND_ENDPOINT_URL}/api`,
    apiEndpoint: `${CLIENT_BACKEND_ENDPOINT_URL}/api`
  },

  //Socket URL
  // In the browser, always use the page's own origin: webpack does not bake
  // SOCKET_URL into the client bundle (DefinePlugin only defines BROWSER and
  // __DEV__), so the env fallback silently pinned every deployment's browsers
  // to the hardcoded CLIENT_BACKEND_ENDPOINT_URL — which broke new-order
  // dialogs on any host that isn't the hardcoded one (e.g. vin). nginx proxies
  // /socket.io on each host to that host's own socket server, so same-origin
  // is correct everywhere. Server-side code (socketNotification relay) keeps
  // the env-driven absolute URL.
  socketUrl:
    typeof window !== 'undefined' && window.location && window.location.origin
      ? window.location.origin
      : process.env.SOCKET_URL || CLIENT_BACKEND_ENDPOINT_URL,

  // Database
  databaseUrl: process.env.DATABASE_URL,

  // Admin alerts are owned by super-api — it holds the bot token, the Firebase
  // credentials and the formatters. We only hand it an event, over the same
  // address the rest of this app already uses for super-api, so it follows
  // dev/prod on its own. The secret is the on switch: unset disables the bridge.
  superApiBridge: {
    baseUrl: process.env.API_SERVER_URL || `${CLIENT_BACKEND_ENDPOINT_URL}/api`,
    secret: process.env.TELEGRAM_INTERNAL_SECRET,
  },

  // CRONs Timezone
  cronTimezone: process.env.CRON_TIMEZONE,
  // Refer this link for valid timezone https://raw.githubusercontent.com/node-cron/tz-offset/master/generated/offsets.json

  // Licence Upload
  licenseuploadDir: process.env.LICENSE_UPLOAD_DIR || '/images/license/',

  // Vehicle Upload
  vehicleUploadDir: process.env.VEHICLE_UPLOAD_DIR || '/images/vehicle/',

  // Profile photo upload
  profilePhotouploadDir: process.env.PROFILE_PHOTO_UPLOAD_DIR || '/images/avatar/',

  // category photo upload
  categoryUploadDir: process.env.CATEGORY_PHOTO_UPLOAD_DIR || '/images/category/',

  // Logo photo upload
  logoUploadDir: process.env.LOGO_PHOTO_UPLOAD_DIR || '/images/logo/',

  // homepage photo upload
  homepageUploadDir: process.env.HOMEPAGE_UPLOAD_DIR || '/images/homepage/',

  // staticpage photo upload
  staticpageUploadDir: process.env.STATICPAGE_UPLOAD_DIR || '/images/staticpage/',

  // Delivery Vehicle Upload
  deliveryVehicleUploadDir: process.env.DELIVERY_VEHICLE_UPLOAD_DIR || '/images/delivery-vehicle/',

  //contentpage photo upload
  contentPageUploadDir: process.env.CONTENTPAGE_UPLOAD_DIR || '/images/contentpage/',

  //banner photo upload
  bannerUploadDir: process.env.BANNER_UPLOAD_DIR || '/images/banner/',

  //storeImage photo upload
  storeImageUploadDir: process.env.STORE_IMAGE_UPLOAD_DIR || '/images/store-image/',

  //storeImage photo upload
  storeDocumentUploadDir: process.env.STORE_DOCUMENT_UPLOAD_DIR || '/images/store-document/',

  //Partner Home page Image photo upload
  partnerHomepageUploadDir: process.env.PARTNER_HOMEPAGE_UPLOAD_DIR || '/images/partner-homepage/',

  // store Item Image
  itemImageUploadDir: process.env.ITEM_IMAGE_UPLOAD_DIR || '/images/store-itemImage/',

  // PromoCode Image
  promoCodeImageUploadDir: process.env.PROMO_CODE_IMAGE_UPLOAD_DIR || '/images/promo-code/',

  // Shop Category Icon Upload
  shopCategoryIconUploadDir: process.env.SHOP_CATEGORY_ICON_UPLOAD_DIR || '/images/shop-category-icons/',


  // favicon upload
  faviconUploadDir: process.env.FAVICON_UPLOAD_DIR || '/images/favicon/',

  // DeliveryType Image
  deliveryTypeImageUploadDir: process.env.DELIVERY_TYPE_IMAGE_UPLOAD_DIR || '/images/delivery-type/',

  // Tone Upload
  toneUploadDir: process.env.TONE_UPLOAD_DIR || '/images/tone/',

  //Google map api key
  googleMapAPI: 'AIzaSyBTZX3vuRdQgFClClP5zO4iWF67E2JptEg',

  // Web analytics
  analytics: {
    // https://analytics.google.com/
    googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },

  // Payment - Stripe (legacy) / Xendit (card payments since the Xendit migration)
  payment: { /* From ENV */
    stripe: {
      secretKey: process.env.STRIPE_SECRET
    },
    xendit: {
      secretKey: process.env.XENDIT_SECRET_KEY
    }
  },

  // Authentication
  auth: {
    jwt: { secret: process.env.JWT_SECRET },

    // https://developers.facebook.com/
    facebook: {
      id: process.env.FACEBOOK_APP_ID,
      secret: process.env.FACEBOOK_APP_SECRET
    },

    // https://cloud.google.com/console/project
    google: {
      id:
        process.env.GOOGLE_CLIENT_ID,
      secret: process.env.GOOGLE_CLIENT_SECRET
    },

    // https://apps.twitter.com/
    twitter: {
      key: process.env.TWITTER_CONSUMER_KEY,
      secret: process.env.TWITTER_CONSUMER_SECRET
    }
  },

  firebaseConfig: {
    apiKey: '<Your API Key>',
    authDomain: '<Your domain>',
    projectId: '<Your project ID>',
    storageBucket: '<Your storage bucket>',
    messagingSenderId: '<Your sender ID>',
    appId: '<Your APP ID>',
    measurementId: '<Your measurement ID >'
  },

  vapidKey: '<Your vapid key>',
  enableFirebase: false
};
